import{a as r}from"./chunk-RAAYCPUM.js";function s(...t){return r(i,t)}var i=(t,n)=>t.startsWith(n);export{s as a};
